/* eslint-disable prettier/prettier */
import { snakeToCamelTemplateLiterals } from '@/common/converter/utils/snake-to-camel'
import { replacePlaceholder } from '@/common/converter/utils/replace-placeholder'
import { convertCellEvent } from '@/common/converter/convert-cell-event'
import { convertTitleList } from '@/common/converter/convert-title-list'

/**
 * source object (home) 와 target object (catalog) 를 받아
 * big banner cell 로 변환한다.
 * PC 에서는 landscape_large, 모바일에서는 portrait 를 사용
 *
 * notes:
 * landscape for TV,
 * landscape_large for PC, tablet,
 * portrait for mobile
 * @param source
 * @param target
 * @returns {{image: {thumbnail: string, banner_background: string, banner_layer: string, landscape_large: {background: string, text: string}, portrait: {background: string, text: string}, landscape: {background: string, text: string}}, thumbnail: string, alt: string, event_list: {bodylist: *, url: string}[], brand_taglist: string[], force_refresh: string, title_list: unknown[], top_taglist: (string[]|*[])}}
 */
export const convertCellBigBanner = (source = {}, target = {}) => {
  const { contextProperty = {}, eventList = [] } = source

  const alt = snakeToCamelTemplateLiterals(contextProperty?.alt) ?? ''
  const brandTagList = contextProperty?.tag?.brandList ?? []
  const topTagList = contextProperty?.tag?.topList ?? []
  const titleList = contextProperty?.titleList.map(snakeToCamelTemplateLiterals) ?? []
  const background = snakeToCamelTemplateLiterals(contextProperty?.image?.landscapeLarge?.background) ?? ''
  const text = snakeToCamelTemplateLiterals(contextProperty?.image?.landscapeLarge?.layer) ?? ''

  return {
    alt: replacePlaceholder(alt, target),
    brand_taglist: brandTagList.map((tag) => replacePlaceholder(tag, target)),
    event_list: eventList.map((event) => convertCellEvent(event, target)),
    force_refresh: 'n',
    image: {
      thumbnail: '',
      banner_background: '',
      banner_layer: '',
      landscape: {},
      landscape_large: {
        background: replacePlaceholder(background, target),
        text: replacePlaceholder(text, target),
      },
      portrait: {},
    },
    thumbnail: '',
    title_list: titleList.map((title) => convertTitleList(replacePlaceholder(title, target)) ?? []),
    top_taglist: topTagList.map((tag) => replacePlaceholder(tag, target)) ?? [],
  }
}
